window.sfDocumentReady(['route-customer-condition-min-reqs-index'], () => {
  // initialize data table
  window.setupDatatable('.js-datatable', 'asc');

  // trigger form submission upon confirmation, when delete link is clicked
  $(document).on('click', '#delete_customer_condition_min_reqs_link', function() {
    const shouldDelete = confirm(
      'Are you sure you want to delete this condition?'
    );
    if (shouldDelete) {
      $(this)
        .parents('form:first')
        .trigger('submit');
    } else {
      return false;
    }
  });
});
